export default "__VITE_ASSET__2z0soctM__"